var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F1F1F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9102 11C17.2932 11 15.1641 13.1291 15.1641 15.7461C15.1641 18.3631 17.2932 20.4922 19.9102 20.4922C22.5272 20.4922 24.6562 18.3631 24.6562 15.7461C24.6562 13.1291 22.5272 11 19.9102 11Z",
    fill: "#4251DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8152 23.5928C24.5158 22.2734 22.7933 21.5469 20.9648 21.5469H18.8555C17.0271 21.5469 15.3045 22.2734 14.0051 23.5928C12.7121 24.9057 12 26.6387 12 28.4727C12 28.7639 12.2361 29 12.5273 29H27.293C27.5842 29 27.8203 28.7639 27.8203 28.4727C27.8203 26.6387 27.1082 24.9057 25.8152 23.5928Z",
    fill: "#4251DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.ee641e9a2799d6bea8622338f52f2399.svg";
export { ForwardRef as ReactComponent };